import { Button, IconButton } from "@mui/material";
import { GridToolbar } from "@progress/kendo-react-grid";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ChairIcon from "@mui/icons-material/Chair";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { setButtonsState } from "../../../redux/features/appStateSlice";
import { User } from "../../../models/User";
import { Banniere } from "../../../models/Banniere";
import { Magasin } from "../../../models/Magasin";
import { Division } from "../../../models/Division";
import { Section } from "../../../models/Section";
import { Activite } from "../../../models/Activite";
import { Statut } from "../../../models/Statut";
import FiltersList from "./FiltersList";
import { Fournisseur } from "../../../models/Fournisseur";
import { Collection } from "../../../models/Collection";
import { planoAPI } from "../../../redux/features/cache";

interface ToolbarProps {
  setMode: React.Dispatch<React.SetStateAction<string>>;
  setSelectedRow: React.Dispatch<React.SetStateAction<number | null>>;
  setOpenNewProduit: React.Dispatch<React.SetStateAction<boolean>>;
  setAddProductTitle: React.Dispatch<React.SetStateAction<string>>;
  user: User[];
  ban: Banniere[];
  mag: Magasin[];
  div: Division[];
  section: Section[];
  currentAcc: Activite[];
  statut: Statut[];
  four: Fournisseur[];
  collection: Collection[];
  setCollection: React.Dispatch<React.SetStateAction<string>>;
  setSection: React.Dispatch<React.SetStateAction<string>>;
  setDivision: React.Dispatch<React.SetStateAction<string>>;
  setBanniere: React.Dispatch<React.SetStateAction<string>>;
  setMagasin: React.Dispatch<React.SetStateAction<string>>;
  setFournisseur: React.Dispatch<React.SetStateAction<string>>;
  setStatut: React.Dispatch<React.SetStateAction<string>>;
  setActivite: React.Dispatch<React.SetStateAction<string>>;
  setAcheteur: React.Dispatch<React.SetStateAction<string>>;
  updateObject: any;
}

function Toolbar(props: ToolbarProps) {
  const dispatch = useAppDispatch();
  const buttonsState = useAppSelector((state) => state.appState.buttonsState);
  const d_inv01rp = useAppSelector((state) => state.appState.d_inv01rp);

  const invalidateQueries = () => {
    dispatch(planoAPI.util.invalidateTags(["planogramme", "plano"]));
  };

  return (
    <GridToolbar className="icon-toolbar">
      <div>
        <IconButton
          sx={{
            "&.MuiButtonBase-root:hover": {
              bgcolor: buttonsState.productView ? "#0257d5" : "#e4e7eb",
            },
            backgroundColor: buttonsState.productView ? "#0257d5" : "#e4e7eb",
            borderRadius: "5px 0 0 5px",
          }}
          onClick={() => {
            dispatch(setButtonsState({ productView: true, storeView: false }));
            props.setMode("");
          }}
        >
          <ChairIcon
            sx={{ color: buttonsState.productView ? "white" : "black" }}
          />
        </IconButton>
        <IconButton
          sx={{
            "&.MuiButtonBase-root:hover": {
              bgcolor: buttonsState.storeView ? "#0257d5" : "#e4e7eb",
            },
            backgroundColor: buttonsState.storeView ? "#0257d5" : "#e4e7eb",
            borderRadius: "0 5px 5px 0",
          }}
          onClick={() => {
            dispatch(setButtonsState({ productView: false, storeView: true }));
            props.setMode("MagProd");
          }}
        >
          <StorefrontIcon
            sx={{ color: buttonsState.storeView ? "white" : "black" }}
          />
        </IconButton>
        <span
          className="k-icon k-font-icon k-i-refresh k-icon-lg"
          style={{ cursor: "pointer", marginTop: "10px", marginLeft: "25px" }}
          onClick={() => {
            invalidateQueries();
          }}
        />
      </div>
      <FiltersList
        activites={props.currentAcc}
        bannieres={props.ban}
        divisions={props.div}
        magasins={props.mag}
        sections={props.section}
        statuts={props.statut}
        fournisseurs={props.four}
        acheteurs={props.user}
        collections={props.collection}
        setCollection={props.setCollection}
        setAcheteur={props.setAcheteur}
        setActivite={props.setActivite}
        setBanniere={props.setBanniere}
        setDivision={props.setDivision}
        setFournisseur={props.setFournisseur}
        setMagasin={props.setMagasin}
        setSection={props.setSection}
        setStatut={props.setStatut}
        updateObject={props.updateObject}
      />
      <Button
        onClick={() => {
          props.setSelectedRow(null);
          props.setOpenNewProduit(true);
          props.setAddProductTitle("Ajouter un nouveau produit");
        }}
        variant="contained"
        sx={{
          width: "275px",
          borderRadius: "30px",
          backgroundColor: "#007bff",
        }}
        disabled={!d_inv01rp.canAdd}
      >
        Ajouter un nouveau produit
      </Button>
    </GridToolbar>
  );
}

Toolbar.displayName = "KendoReactGridToolbar"; //Important sinon Kendo n'affiche pas le component'

export default Toolbar;
